/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentDto
 */
export interface PaymentDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentDto
     */
    scheduledDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentDto
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    status: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDto
     */
    isPaid: boolean;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    paymentNumber: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    prixClient: number;
    /**
     * 
     * @type {Date}
     * @memberof PaymentDto
     */
    withdrawalDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    directDebitReference?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    clientPrice: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    priceExcludingTax: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    feesAmount: number;
}

/**
 * Check if a given object implements the PaymentDto interface.
 */
export function instanceOfPaymentDto(value: object): value is PaymentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('scheduledDate' in value) || value['scheduledDate'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isPaid' in value) || value['isPaid'] === undefined) return false;
    if (!('paymentNumber' in value) || value['paymentNumber'] === undefined) return false;
    if (!('prixClient' in value) || value['prixClient'] === undefined) return false;
    if (!('clientPrice' in value) || value['clientPrice'] === undefined) return false;
    if (!('priceExcludingTax' in value) || value['priceExcludingTax'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('feesAmount' in value) || value['feesAmount'] === undefined) return false;
    return true;
}

export function PaymentDtoFromJSON(json: any): PaymentDto {
    return PaymentDtoFromJSONTyped(json, false);
}

export function PaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'scheduledDate': (new Date(json['scheduledDate'])),
        'dueDate': (new Date(json['dueDate'])),
        'status': json['status'],
        'isPaid': json['isPaid'],
        'paymentNumber': json['paymentNumber'],
        'prixClient': json['prixClient'],
        'withdrawalDate': json['withdrawalDate'] == null ? undefined : (new Date(json['withdrawalDate'])),
        'directDebitReference': json['directDebitReference'] == null ? undefined : json['directDebitReference'],
        'clientPrice': json['clientPrice'],
        'priceExcludingTax': json['priceExcludingTax'],
        'tax': json['tax'],
        'feesAmount': json['feesAmount'],
    };
}

export function PaymentDtoToJSON(json: any): PaymentDto {
    return PaymentDtoToJSONTyped(json, false);
}

export function PaymentDtoToJSONTyped(value?: PaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'scheduledDate': ((value['scheduledDate']).toISOString()),
        'dueDate': ((value['dueDate']).toISOString()),
        'status': value['status'],
        'isPaid': value['isPaid'],
        'paymentNumber': value['paymentNumber'],
        'prixClient': value['prixClient'],
        'withdrawalDate': value['withdrawalDate'] == null ? undefined : ((value['withdrawalDate']).toISOString()),
        'directDebitReference': value['directDebitReference'],
        'clientPrice': value['clientPrice'],
        'priceExcludingTax': value['priceExcludingTax'],
        'tax': value['tax'],
        'feesAmount': value['feesAmount'],
    };
}

